module.exports = __webpack_public_path__ + "static/img/Riff_icon.acbad5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/Riff_icon.png
// module id = DyEB
// module chunks = 12